import React, {useContext, useMemo} from 'react';

const SMCDisabledContext = React.createContext();

export function SMCDisabledProvider({
    forceDisable,
    forceEnable,
    overrideDisabledContext,
    children
}) {
    const disabledProvider = useSMCDisabledContext();

    const value = useMemo(() => {
        let _forceDisable = forceDisable;
        let _forceEnable = forceEnable;
        // If not override disabled context, respect previous values if they exist
        if (disabledProvider && !overrideDisabledContext) {
            _forceDisable |= disabledProvider.forceDisable;
            _forceEnable |= disabledProvider.forceEnable;
        }

        return {
            forceDisable: _forceDisable,
            forceEnable: _forceEnable,
        }
    }, [forceDisable, forceEnable, disabledProvider, overrideDisabledContext]);

    return (
        <>
        <SMCDisabledContext.Provider value={value}>
            {children}
        </SMCDisabledContext.Provider>
        </>
    );
}

export function useSMCDisabledContext() {
    return useContext(SMCDisabledContext);
}